import { HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import {
    ICON_CIRCLE_CENTER,
    ICON_CIRCLE_RADIUS,
    ICON_DOT_RADIUS,
    ICON_DOT_X,
    ICON_DOT_Y,
    ICON_SIZE,
    ICON_STEM_X,
    ICON_STEM_Y_END,
    ICON_STEM_Y_START,
    ICON_STROKE_WIDTH,
    NOTE_TEXT,
    TEST_ID
} from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FooterNote: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <HorizontalContainer className={`${styles.footerNote} ${className}`} testId={testId}>
        <svg
            aria-hidden='true'
            className={styles.icon}
            fill='none'
            height={ICON_SIZE}
            viewBox={`0 0 ${ICON_SIZE} ${ICON_SIZE}`}
            width={ICON_SIZE}
            xmlns='http://www.w3.org/2000/svg'>
            <circle
                cx={ICON_CIRCLE_CENTER}
                cy={ICON_CIRCLE_CENTER}
                fill='none'
                r={ICON_CIRCLE_RADIUS}
                stroke='currentColor'
                strokeWidth={ICON_STROKE_WIDTH}
            />

            <line
                stroke='currentColor'
                strokeLinecap='round'
                strokeWidth={ICON_STROKE_WIDTH}
                x1={ICON_STEM_X}
                x2={ICON_STEM_X}
                y1={ICON_STEM_Y_START}
                y2={ICON_STEM_Y_END}
            />

            <circle cx={ICON_DOT_X} cy={ICON_DOT_Y} fill='currentColor' r={ICON_DOT_RADIUS} />
        </svg>

        <Wrapper className={styles.text}>{NOTE_TEXT}</Wrapper>
    </HorizontalContainer>
);

export default FooterNote;
